import FontFaceObserver from 'fontfaceobserver';


let fonts = {
  neutrifStudio: {
    regular: new FontFaceObserver('Neutrif Studio', { weight: 400 }),
    bold: new FontFaceObserver('Neutrif Studio', { weight: 700 }),
  },
  bebasNeue: {
    regular: new FontFaceObserver('Bebas Neue', { weight: 400 }),
    bold: new FontFaceObserver('Bebas Neue', { weight: 700 }),
  },
};

export default fonts